import { parse, ParseConfig } from 'papaparse'

const parseCsv = <FileInterface>(csv: string) => {
  const parseParams: ParseConfig = {
    header: true,
    skipEmptyLines: true,
  }

  const { data: jsonData } = parse<FileInterface>(csv, parseParams)
  return jsonData
}

export default parseCsv
